/**
 * 
 * key
 * 
 */


const key = 'ZXF1aXBtZW50X21hc3Rlcg=='

export default key 